import React from 'react';
import { FiImage } from 'react-icons/fi';
import useImageRecovery from '../../hooks/useImageRecovery';

const RecoverableImage = React.forwardRef(function RecoverableImage({
    as: Image = 'img', src, sources = [], refresh, allowRefresh = false, alt = '', fallback, style, ...props
}, ref) {
    const recovery = useImageRecovery({ sources: [src, ...sources], refresh, allowRefresh });
    return recovery.src ? <Image {...props} ref={ref} src={recovery.src} alt={alt} style={style} onError={recovery.onError} /> :
        fallback || <span role="img" aria-label={alt || undefined} className={props.className}
            style={{ ...style, minHeight: typeof style?.height === 'number' ? Math.min(style.height, 40) : 40, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
            <FiImage aria-hidden="true" />
        </span>;
});
export default RecoverableImage;
